import React from 'react';
import { useNavigate } from 'react-router-dom';

function CustomersLoansHub() {
  const navigate = useNavigate();

  return (
    <div className="admin-dashboard-container">
      {/* Header with Back Button */}
      <div className="admin-hub-header">
        <button
          onClick={() => navigate('/admin')}
          className="admin-hub-back-btn"
        >
          <span className="admin-hub-back-arrow">←</span>
          Back to Dashboard
        </button>
        <h1 className="admin-page-title">Customers & Loans</h1>
        <p className="admin-hub-subtitle">Manage customer accounts, loans, and payment tracking</p>
      </div>

      {/* Hub Cards Grid */}
      <div className="admin-hub-grid">
        <div className="card admin-menu-card" onClick={() => navigate('/admin/customers')}>
          <div className="admin-hub-card-icon">👥</div>
          <h2>Customer Management</h2>
          <p>View and manage customer accounts. Update contact information, view purchase history, and manage account status.</p>
          <button className="btn btn-primary">Manage Customers</button>
        </div>

        <div className="card admin-menu-card" onClick={() => navigate('/admin/loans')}>
          <div className="admin-hub-card-icon">💰</div>
          <h2>Loan Management</h2>
          <p>Track active loans, view payment schedules, and manage loan modifications. Monitor balances and payment status.</p>
          <button className="btn btn-primary">Manage Loans</button>
        </div>

        <div className="card admin-menu-card" onClick={() => navigate('/admin/payments')}>
          <div className="admin-hub-card-icon">💳</div>
          <h2>Payment Tracking</h2>
          <p>View payment history, record manual payments, and generate payment reports. Track on-time and late payments.</p>
          <button className="btn btn-primary">View Payments</button>
        </div>

        <div className="card admin-menu-card" onClick={() => navigate('/admin/loans/import')}>
          <div className="admin-hub-card-icon">📥</div>
          <h2>Import Loan</h2>
          <p>Import existing loans from spreadsheets or other systems. Quickly add historical loan data to the platform.</p>
          <button className="btn btn-primary">Import Loan</button>
        </div>
      </div>
    </div>
  );
}

export default CustomersLoansHub;
